export const pl = {
  returnLineItems: {
    refund: "Zwrot(y)",
    exchange: "Wymiana/wymiany",
    discount: "Rabat(y)",
  },
  returnStoreAddress: {
    mapButton: "Zobacz na mapie",
  },
  downloadLabel: {
    label: "Pobierz etykietę",
    bonDeRetour: "Pobierz formularz zwrotu",
  },
  returnRequestDate: {
    label: "Twoje zgłoszenie zwrotu zostało złożone {{date}} o {{time}}",
  },
  actions: {
    continue: "Kontynuuj",
  },
  "order-identification": {
    title: "Śledź swoje zamówienie",
    description: "Wprowadź dane zamówienia, aby śledzić paczkę",
    fields: {
      "zip-code": {
        title: "Kod pocztowy",
        description: "Wprowadź kod pocztowy dostawy",
        required: "Kod pocztowy jest wymagany",
      },
      "tracking-number": {
        title: "Numer zamówienia",
        description: "Wprowadź numer zamówienia",
        required: "Numer zamówienia jest wymagany",
      },
    },
    errors: {
      "unknown-order": {
        title: "Nieznany numer zamówienia",
        description: "Nie znaleziono numeru zamówienia, sprawdź go",
      },
      "search-error": {
        title: "Błąd wyszukiwania",
        description:
          "Nie udało się znaleźć zamówienia. Spróbuj ponownie później.",
      },
    },
  },
  delivery: "Dostawa",
  "parcel-history": "Historia paczki",
  "order-details": {
    title: "Szczegóły zamówienia",
    "tracking-number": "Numer śledzenia",
    "order-number": "Numer zamówienia",
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "Szacowana data dostawy",
      deliveredOn: "Dostarczono",
      from: "od",
      to: "do",
    },
  },
  deliveryAddress: {
    title: "Adres dostawy:",
    titlePickup: "Adres punktu odbioru:",
    orderDetails: {
      title: "Szczegóły zamówienia:",
      trackingNumber: "Numer śledzenia:",
      orderNumber: "Numer zamówienia:",
      orderDate: "Data zamówienia:",
    },
  },
  pickupPoint: {
    title: "Punkt odbioru",
    openingHours: "Godziny otwarcia:",
    closed: "Zamknięte",
    directions: "Wskazówki dojazdu",
    days: {
      monday: "Poniedziałek:",
      tuesday: "Wtorek:",
      wednesday: "Środa:",
      thursday: "Czwartek:",
      friday: "Piątek:",
      saturday: "Sobota:",
      sunday: "Niedziela:",
    },
  },
  wallet: {
    warningNotEnabled: "Musisz włączyć Wallet w ustawieniach sklepu",
  },
  crossSell: {
    youMightAlsoLike: "Może ci się też spodobać",
  },
  "rate-order": {
    "order-recap": {
      title: "Twoje zamówienie",
      "tracking-label": "Numer śledzenia:",
      "order-label": "Numer zamówienia:",
    },
    form: {
      title: "Oceń swoją dostawę",
      "rating-label": "Oceń swoje doświadczenie z dostawą",
      "comment-label": "Komentarz (opcjonalnie)",
      "comment-placeholder": "Podziel się z nami swoim doświadczeniem…",
      "submit-cta": "Wyślij moją ocenę",
      "update-cta": "Zaktualizuj moją ocenę",
      "rating-required": "Proszę wybrać ocenę.",
    },
    "thank-you": {
      title: "Dziękujemy za opinię!",
      description:
        "Twoja ocena została zapisana. Pomoże nam poprawić doświadczenie z dostawą.",
    },
    errors: {
      "invalid-token": {
        title: "Nieprawidłowy lub wygasły link",
        description:
          "Ten link nie jest już ważny. Otwórz go ponownie z najnowszej wiadomości e-mail ze śledzeniem.",
      },
      submit: {
        title: "Coś poszło nie tak",
        description:
          "Nie udało nam się zapisać Twojej oceny. Spróbuj ponownie później.",
      },
    },
  },
} as const;
